import { normalizePermissions } from "../helpers/helper"


const USER_CONTEXT_KEY = "userContext";

export function readUserContext() {
    const storedContext = sessionStorage.getItem(USER_CONTEXT_KEY);

    if (!storedContext) {
        return null;
    }

    try {
        const userContext = JSON.parse(storedContext);

        if (
            !userContext ||
            typeof userContext !== "object" ||
            !Array.isArray(userContext.permissions)
        ) {
            sessionStorage.removeItem(USER_CONTEXT_KEY);
            return null;
        }

        return {
            ...userContext,
            permissions: normalizePermissions(userContext.permissions)
        };
    } catch (error) {
        sessionStorage.removeItem(USER_CONTEXT_KEY);
        return null;
    }
}
export function saveUserContext(userContext) {
    if (!userContext || typeof userContext !== "object") {
        return false;
    }

    if (!Array.isArray(userContext.permissions)) {
        return false;
    }

    const normalizedContext = {
        ...userContext,
        permissions: normalizePermissions(userContext.permissions)
    };

    try {
        sessionStorage.setItem(
            USER_CONTEXT_KEY,
            JSON.stringify(normalizedContext)
        );

        return true;
    } catch (error) {
        return false;
    }
}

export function normalizePermissionGroup(value) {
    if (Array.isArray(value)) {
        return normalizePermissions(value);
    }

    if (value && typeof value === "object") {
        return normalizePermissions(Object.values(value));
    }

    return [];
}

export function clearUserContext() {
    sessionStorage.removeItem(USER_CONTEXT_KEY);
}